import { addPagesAppSystem } from './addPagesAppSystem';
import { billingPages } from './billingPages';
import { mainPages } from './mainPages';
import { ocsPages } from './ocsPages';
import { pagesPublic } from './publicPages';
import { sortMenu } from './sortMenu';
import { supportPages } from './supportPages';
import { AppStatus, AppSystem, IPage } from '../../interfaces';

const addDefaultAppStatus = (pages: IPage[]): IPage[] => {
    return pages.map((p: IPage) => ({
        ...p,
        appStatus: p.appStatus ? p.appStatus : AppStatus.READY,
        ...{ subMenu: p.subMenu && p.subMenu.length ? addDefaultAppStatus(p.subMenu) : undefined },
    }));
};

const calcAllPageList = (pages: IPage[]): IPage[] => {
    let list: IPage[] = [];
    pages.forEach((p: IPage) => {
        list.push(p);
        if (p.subMenu && Array.isArray(p.subMenu) && p.subMenu.length) {
            list = list.concat(calcAllPageList(p.subMenu));
        }
    });

    return list;
};

const pagesBook: IPage[] = sortMenu([
    ...pagesPublic,
    ...mainPages,
    ...addPagesAppSystem(supportPages, AppSystem.OCS),
    ...addPagesAppSystem(ocsPages, AppSystem.OCS),
    ...addPagesAppSystem(billingPages, AppSystem.BILLING),
]);

export const pagesMap: IPage[] = addDefaultAppStatus(pagesBook);

export const allPageList = calcAllPageList(pagesBook);
